import React from "react";
import ForgotPassword from "../Components/ForgotPassword/ForgotPassword";

const ForgotPasswordPage: React.FC = () => {
  return <ForgotPassword />;
};

export default ForgotPasswordPage;
